module.exports = __webpack_public_path__ + "img/picture5.4839addc.png";